// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conclusion-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
}

.conclusion-container {
  width: 100%;
  max-width: 600px; /* Adjust as needed for your design */
  margin: 0 auto;
  padding-top: 50px;
  padding-bottom: 20px; /* Add extra padding at the bottom */
  overflow: auto;
  justify-content: center;
  align-items: center;
}
.conclusion-content {
  color: white;
  max-width: 700px; /* Adjust as needed */
  margin: 0 auto;
  font-family: Arial, sans-serif; 
  justify-content: center;
  align-items: center;
}
.conclusion-title {
  color: white;
  font-weight: bold;
  justify-content: center;
  font-size: 4em;
  margin-bottom: 0px;
  align-items: center;
}

.conclusion-key {
  color: rgb(242, 100, 100);
  justify-content: center;
  align-items: center;
  /* font-size: 3em; */
}

.conclusion-img {
  width: 74%;
  height: auto;
  filter: drop-shadow(0 0 8px grey);
  justify-content: center;

  
}
.conclusion-text {
  font-size: 1.123em; /* Adjust as needed */
  justify-content:flex-start;
  text-align: left;
  align-items:flex-start;
  font-size: 1.123em;
  line-height: 1.4;
  padding-right: 10px;
  padding-left: 10px;
}

.regster-button{

background-color: #4cadaf; /* Green */
border: none;
color: rgb(12, 90, 180);
padding: 15px 32px;
text-align: center;
text-decoration: none;
display: inline-block;
font-size: 14px;
margin: 4px 2px;
cursor: pointer;
border-radius: 12px;
transition-duration: 0.4s;

}

.start-again-button {
  background-color: #4CAF50; /* Green */
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 12px;
  transition-duration: 0.4s;
  margin-right: 25px;
  min-width: 280px;
  }

.start-again-button:hover {
  background-color: white; 
  color: black; 
  border: 2px solid #4CAF50;
}

@media (max-width: 600px) {
  /* Adjust styles for smaller devices */
  .start-again-button {
    margin-right: 0; /* Remove the margin from the right of the buttons */
    margin-bottom: 10px; /* Adds space below each button */}
}

.preben-type-button {
  background-color: #4CAF50; /* Green */
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 12px;
  transition-duration: 0.4s;
  min-width: 280px;
}

.preben-type-button:hover {
  background-color: white; 
  color: black; 
  border: 2px solid #4CAF50;
}

/* styles.css */
.register-button {
background-color: #4CAF50; /* Green */
border: none;
color: white;
padding: 15px 32px;
text-align: center;
text-decoration: none;
display: inline-block;
font-size: 16px;
margin: 4px 2px;
cursor: pointer;
}

/* styles.css */
.register {
background-color: #9eaf4c; /* Green */
border: none;
color: rgb(240, 236, 6);
padding: 15px 32px;
text-align: center;
text-decoration: none;
display: inline-block;
font-size: 16px;
margin: 4px 2px;
cursor: pointer;
}

.registration-form {
display: flex;
flex-direction: column;
width: 300px;
margin: auto;
font-size: 18px; /* Increase the font size */
}

.registration-form label {
margin-bottom: 10px;
}

.registration-form input[type="text"],
.registration-form input[type="email"] {
margin-bottom: 20px;
height: 30px; /* Increase the height of the input fields */
font-size: 16px; /* Increase the font size in the input fields */
}

.conclusion-content {
/* Your existing styles for larger devices */

  /* Additional styles for smaller devices */
  @media (max-width: 600px) {
    /* Adjust styles for smaller devices */
    font-size: 14px; /* Example adjustment, modify as needed */
  }
}

/* styles.css */
.thinking-animation {
display: flex;
flex-direction: column;
justify-content: center;
height: 100vh;
background-color: #282c34;
color: white;
font-size: 24px;
}

.thinking-animation .emoji {
font-size: 50px;
margin-bottom: 20px; 
}
.thinking{
display: flex;
margin-right: auto;
margin-left: auto;
filter: drop-shadow(0 0 8px grey);
}

.thinking-animation .spinner {
margin-bottom: 30px;
width: 50px;
height: 50px;
border: 4px solid #f3f3f3;
border-top: 4px solid #3498db;
border-radius: 50%;
animation: spin 2s linear infinite;
}

/* styles.css */
.thinking-text {
color: #fff; /* Change the color of the text */
/*   text-shadow: 2px 2px 4px rgba(221, 200, 255, 0.5); */ /* Add a shadow to the text */
font-size: 24px; /* Increase the size of the text */
font-weight: bold; /* Make the text bold */
padding-left: 10px;
padding-right: 10px;
text-align: center; /* Center the text */
}
@keyframes spin {
0% { transform: rotate(0deg); }
100% { transform: rotate(360deg); }
}
@media (max-width: 800px) {
  .conclusion-content {
    max-width: 100%; /* Adjust as needed */
  }
  .conclusion-title{
    font-size: 3em;
    padding-right: 10px;
    padding-left: 10px;
  }
  .conclusion-key{
    font-size: 41px;
    padding-right: 10px;
    padding-left: 10px;
  }
 
}
 
@media (min-width:2400px) and (max-width: 3440px) {

  .conclusion-container{
    zoom: 1.6;
  }
}

/* 1179×2556 pixels at 460ppi  For iPhone 14 Pro, iPhone 15 and iPhone 15 Pro: */
@media screen 
and (width: 393px) 
and (height: 852px) 
and (-webkit-device-pixel-ratio: 3) {
.thinking{
  display: flex;
  margin-right: auto;
  margin-left: auto;
  filter: drop-shadow(0 0 8px grey);
}
} 
/* 1284×2778 pixels at 460ppi For iPhone 14 Pro Max, iPhone 15 Plus and iPhone 15 Pro Max: */
@media  screen 
  and (width: 430px) 
  and (height: 932px) 
  and (-webkit-device-pixel-ratio: 3) {
    .thinking{
      display: flex;
      margin-right: auto;
      margin-left: auto;
      filter: drop-shadow(0 0 8px grey);
    }
   } 
/* 1170×2532 pixels at 460ppi For iPhone 12, iPhone 12 Pro, iPhone 13, iPhone 13 Pro, and iPhone 14: */
@media  screen 
and (width: 390px) 
and (height: 844px) 
and (-webkit-device-pixel-ratio: 3) {
.thinking{
      display: flex;
      margin-right: auto;
      margin-left: auto;
      filter: drop-shadow(0 0 8px grey);
    }
}
/* 1284×2778 pixels at 458ppi For iPhone 12 Pro Max, iPhone 13 Pro Max, and iPhone 14 Plus:*/
@media  screen 
  and (min-device-width: 428px) 
  and (height: 926px) 
  and (-webkit-device-pixel-ratio: 3) {
    .thinking{
      display: flex;
      margin-right: auto;
      margin-left: auto;
      filter: drop-shadow(0 0 8px grey);
    }
} `, "",{"version":3,"sources":["webpack://./src/components/css/conclusion.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB,EAAE,qCAAqC;EACvD,cAAc;EACd,iBAAiB;EACjB,oBAAoB,EAAE,oCAAoC;EAC1D,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB,EAAE,qBAAqB;EACvC,cAAc;EACd,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iCAAiC;EACjC,uBAAuB;;;AAGzB;AACA;EACE,kBAAkB,EAAE,qBAAqB;EACzC,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;AAEA,yBAAyB,EAAE,UAAU;AACrC,YAAY;AACZ,uBAAuB;AACvB,kBAAkB;AAClB,kBAAkB;AAClB,qBAAqB;AACrB,qBAAqB;AACrB,eAAe;AACf,eAAe;AACf,eAAe;AACf,mBAAmB;AACnB,yBAAyB;;AAEzB;;AAEA;EACE,yBAAyB,EAAE,UAAU;EACrC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB;;AAEF;EACE,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC;IACE,eAAe,EAAE,oDAAoD;IACrE,mBAAmB,EAAE,iCAAiC,CAAC;AAC3D;;AAEA;EACE,yBAAyB,EAAE,UAAU;EACrC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,eAAe;AACf;AACA,yBAAyB,EAAE,UAAU;AACrC,YAAY;AACZ,YAAY;AACZ,kBAAkB;AAClB,kBAAkB;AAClB,qBAAqB;AACrB,qBAAqB;AACrB,eAAe;AACf,eAAe;AACf,eAAe;AACf;;AAEA,eAAe;AACf;AACA,yBAAyB,EAAE,UAAU;AACrC,YAAY;AACZ,uBAAuB;AACvB,kBAAkB;AAClB,kBAAkB;AAClB,qBAAqB;AACrB,qBAAqB;AACrB,eAAe;AACf,eAAe;AACf,eAAe;AACf;;AAEA;AACA,aAAa;AACb,sBAAsB;AACtB,YAAY;AACZ,YAAY;AACZ,eAAe,EAAE,2BAA2B;AAC5C;;AAEA;AACA,mBAAmB;AACnB;;AAEA;;AAEA,mBAAmB;AACnB,YAAY,EAAE,4CAA4C;AAC1D,eAAe,EAAE,+CAA+C;AAChE;;AAEA;AACA,4CAA4C;;EAE1C,0CAA0C;EAC1C;IACE,sCAAsC;IACtC,eAAe,EAAE,yCAAyC;EAC5D;AACF;;AAEA,eAAe;AACf;AACA,aAAa;AACb,sBAAsB;AACtB,uBAAuB;AACvB,aAAa;AACb,yBAAyB;AACzB,YAAY;AACZ,eAAe;AACf;;AAEA;AACA,eAAe;AACf,mBAAmB;AACnB;AACA;AACA,aAAa;AACb,kBAAkB;AAClB,iBAAiB;AACjB,iCAAiC;AACjC;;AAEA;AACA,mBAAmB;AACnB,WAAW;AACX,YAAY;AACZ,yBAAyB;AACzB,6BAA6B;AAC7B,kBAAkB;AAClB,kCAAkC;AAClC;;AAEA,eAAe;AACf;AACA,WAAW,EAAE,iCAAiC;AAC9C,yDAAyD,EAAE,6BAA6B;AACxF,eAAe,EAAE,kCAAkC;AACnD,iBAAiB,EAAE,uBAAuB;AAC1C,kBAAkB;AAClB,mBAAmB;AACnB,kBAAkB,EAAE,oBAAoB;AACxC;AACA;AACA,KAAK,uBAAuB,EAAE;AAC9B,OAAO,yBAAyB,EAAE;AAClC;AACA;EACE;IACE,eAAe,EAAE,qBAAqB;EACxC;EACA;IACE,cAAc;IACd,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;AAEF;;AAEA;;EAEE;IACE,SAAS;EACX;AACF;;AAEA,gFAAgF;AAChF;;;;AAIA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;AACnC;AACA;AACA,4FAA4F;AAC5F;;;;IAII;MACE,aAAa;MACb,kBAAkB;MAClB,iBAAiB;MACjB,iCAAiC;IACnC;GACD;AACH,sGAAsG;AACtG;;;;AAIA;MACM,aAAa;MACb,kBAAkB;MAClB,iBAAiB;MACjB,iCAAiC;IACnC;AACJ;AACA,4FAA4F;AAC5F;;;;IAII;MACE,aAAa;MACb,kBAAkB;MAClB,iBAAiB;MACjB,iCAAiC;IACnC;AACJ","sourcesContent":[".conclusion-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  text-align: center;\n}\n\n.conclusion-container {\n  width: 100%;\n  max-width: 600px; /* Adjust as needed for your design */\n  margin: 0 auto;\n  padding-top: 50px;\n  padding-bottom: 20px; /* Add extra padding at the bottom */\n  overflow: auto;\n  justify-content: center;\n  align-items: center;\n}\n.conclusion-content {\n  color: white;\n  max-width: 700px; /* Adjust as needed */\n  margin: 0 auto;\n  font-family: Arial, sans-serif; \n  justify-content: center;\n  align-items: center;\n}\n.conclusion-title {\n  color: white;\n  font-weight: bold;\n  justify-content: center;\n  font-size: 4em;\n  margin-bottom: 0px;\n  align-items: center;\n}\n\n.conclusion-key {\n  color: rgb(242, 100, 100);\n  justify-content: center;\n  align-items: center;\n  /* font-size: 3em; */\n}\n\n.conclusion-img {\n  width: 74%;\n  height: auto;\n  filter: drop-shadow(0 0 8px grey);\n  justify-content: center;\n\n  \n}\n.conclusion-text {\n  font-size: 1.123em; /* Adjust as needed */\n  justify-content:flex-start;\n  text-align: left;\n  align-items:flex-start;\n  font-size: 1.123em;\n  line-height: 1.4;\n  padding-right: 10px;\n  padding-left: 10px;\n}\n\n.regster-button{\n\nbackground-color: #4cadaf; /* Green */\nborder: none;\ncolor: rgb(12, 90, 180);\npadding: 15px 32px;\ntext-align: center;\ntext-decoration: none;\ndisplay: inline-block;\nfont-size: 14px;\nmargin: 4px 2px;\ncursor: pointer;\nborder-radius: 12px;\ntransition-duration: 0.4s;\n\n}\n\n.start-again-button {\n  background-color: #4CAF50; /* Green */\n  border: none;\n  color: white;\n  padding: 15px 32px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 16px;\n  margin: 4px 2px;\n  cursor: pointer;\n  border-radius: 12px;\n  transition-duration: 0.4s;\n  margin-right: 25px;\n  min-width: 280px;\n  }\n\n.start-again-button:hover {\n  background-color: white; \n  color: black; \n  border: 2px solid #4CAF50;\n}\n\n@media (max-width: 600px) {\n  /* Adjust styles for smaller devices */\n  .start-again-button {\n    margin-right: 0; /* Remove the margin from the right of the buttons */\n    margin-bottom: 10px; /* Adds space below each button */}\n}\n\n.preben-type-button {\n  background-color: #4CAF50; /* Green */\n  border: none;\n  color: white;\n  padding: 15px 32px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 16px;\n  margin: 4px 2px;\n  cursor: pointer;\n  border-radius: 12px;\n  transition-duration: 0.4s;\n  min-width: 280px;\n}\n\n.preben-type-button:hover {\n  background-color: white; \n  color: black; \n  border: 2px solid #4CAF50;\n}\n\n/* styles.css */\n.register-button {\nbackground-color: #4CAF50; /* Green */\nborder: none;\ncolor: white;\npadding: 15px 32px;\ntext-align: center;\ntext-decoration: none;\ndisplay: inline-block;\nfont-size: 16px;\nmargin: 4px 2px;\ncursor: pointer;\n}\n\n/* styles.css */\n.register {\nbackground-color: #9eaf4c; /* Green */\nborder: none;\ncolor: rgb(240, 236, 6);\npadding: 15px 32px;\ntext-align: center;\ntext-decoration: none;\ndisplay: inline-block;\nfont-size: 16px;\nmargin: 4px 2px;\ncursor: pointer;\n}\n\n.registration-form {\ndisplay: flex;\nflex-direction: column;\nwidth: 300px;\nmargin: auto;\nfont-size: 18px; /* Increase the font size */\n}\n\n.registration-form label {\nmargin-bottom: 10px;\n}\n\n.registration-form input[type=\"text\"],\n.registration-form input[type=\"email\"] {\nmargin-bottom: 20px;\nheight: 30px; /* Increase the height of the input fields */\nfont-size: 16px; /* Increase the font size in the input fields */\n}\n\n.conclusion-content {\n/* Your existing styles for larger devices */\n\n  /* Additional styles for smaller devices */\n  @media (max-width: 600px) {\n    /* Adjust styles for smaller devices */\n    font-size: 14px; /* Example adjustment, modify as needed */\n  }\n}\n\n/* styles.css */\n.thinking-animation {\ndisplay: flex;\nflex-direction: column;\njustify-content: center;\nheight: 100vh;\nbackground-color: #282c34;\ncolor: white;\nfont-size: 24px;\n}\n\n.thinking-animation .emoji {\nfont-size: 50px;\nmargin-bottom: 20px; \n}\n.thinking{\ndisplay: flex;\nmargin-right: auto;\nmargin-left: auto;\nfilter: drop-shadow(0 0 8px grey);\n}\n\n.thinking-animation .spinner {\nmargin-bottom: 30px;\nwidth: 50px;\nheight: 50px;\nborder: 4px solid #f3f3f3;\nborder-top: 4px solid #3498db;\nborder-radius: 50%;\nanimation: spin 2s linear infinite;\n}\n\n/* styles.css */\n.thinking-text {\ncolor: #fff; /* Change the color of the text */\n/*   text-shadow: 2px 2px 4px rgba(221, 200, 255, 0.5); */ /* Add a shadow to the text */\nfont-size: 24px; /* Increase the size of the text */\nfont-weight: bold; /* Make the text bold */\npadding-left: 10px;\npadding-right: 10px;\ntext-align: center; /* Center the text */\n}\n@keyframes spin {\n0% { transform: rotate(0deg); }\n100% { transform: rotate(360deg); }\n}\n@media (max-width: 800px) {\n  .conclusion-content {\n    max-width: 100%; /* Adjust as needed */\n  }\n  .conclusion-title{\n    font-size: 3em;\n    padding-right: 10px;\n    padding-left: 10px;\n  }\n  .conclusion-key{\n    font-size: 41px;\n    padding-right: 10px;\n    padding-left: 10px;\n  }\n \n}\n \n@media (min-width:2400px) and (max-width: 3440px) {\n\n  .conclusion-container{\n    zoom: 1.6;\n  }\n}\n\n/* 1179×2556 pixels at 460ppi  For iPhone 14 Pro, iPhone 15 and iPhone 15 Pro: */\n@media screen \nand (width: 393px) \nand (height: 852px) \nand (-webkit-device-pixel-ratio: 3) {\n.thinking{\n  display: flex;\n  margin-right: auto;\n  margin-left: auto;\n  filter: drop-shadow(0 0 8px grey);\n}\n} \n/* 1284×2778 pixels at 460ppi For iPhone 14 Pro Max, iPhone 15 Plus and iPhone 15 Pro Max: */\n@media  screen \n  and (width: 430px) \n  and (height: 932px) \n  and (-webkit-device-pixel-ratio: 3) {\n    .thinking{\n      display: flex;\n      margin-right: auto;\n      margin-left: auto;\n      filter: drop-shadow(0 0 8px grey);\n    }\n   } \n/* 1170×2532 pixels at 460ppi For iPhone 12, iPhone 12 Pro, iPhone 13, iPhone 13 Pro, and iPhone 14: */\n@media  screen \nand (width: 390px) \nand (height: 844px) \nand (-webkit-device-pixel-ratio: 3) {\n.thinking{\n      display: flex;\n      margin-right: auto;\n      margin-left: auto;\n      filter: drop-shadow(0 0 8px grey);\n    }\n}\n/* 1284×2778 pixels at 458ppi For iPhone 12 Pro Max, iPhone 13 Pro Max, and iPhone 14 Plus:*/\n@media  screen \n  and (min-device-width: 428px) \n  and (height: 926px) \n  and (-webkit-device-pixel-ratio: 3) {\n    .thinking{\n      display: flex;\n      margin-right: auto;\n      margin-left: auto;\n      filter: drop-shadow(0 0 8px grey);\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
